import { IApplicationState } from '../../types/redux';

export function getFlatViewOrderStatusDescription(state: IApplicationState) {
  const { newbuilding } = state;

  return newbuilding?.flatViewOrder?.orderStatus?.description || 'Вы записались на просмотр квартиры в данном ЖК';
}
